import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Jugador } from '@domain/jugador';
import { Equipo } from '@domain/equipo';
import { DashboardProvider } from '@providers/dashboard/dashboard'
import { ASSETS } from '@env';
import { LoadingProvider } from '@providers/loading/loading';

@IonicPage()
@Component({
  selector: 'page-fortalezas-debilidades',
  templateUrl: 'fortalezas-debilidades.html',
})
export class FortalezasDebilidadesPage {

  jugador: Jugador;
  equipo: Equipo;
  categorias: Array<any> = [];
  ICONS_CATEGORIES = ASSETS.ICONS_CATEGORIES;
  campania: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private loadingProvider: LoadingProvider,
    private dashboardProvider: DashboardProvider
  ) {
    this.jugador = navParams.get('jugador');
    this.equipo = navParams.get('equipo');
    this.campania = navParams.get('campania');
  }

  ionViewDidLoad() {
    this.dashboardProvider.detalleCategorias(this.equipo.area._id, this.jugador._id, this.campania? this.campania._id: null)
    .then( categorias => {
      this.categorias = categorias;
    })
    .then( _ => this.loadingProvider.show(false) )
    .catch( e => this.loadingProvider.show(false) )
  }

}



// WEBPACK FOOTER //
// ./src/pages/fortalezas-debilidades/fortalezas-debilidades.ts